import { AxiosInstance } from 'axios';

import { CodeListNormalized } from '../../../store/entities/code/code.types';
import { APIManagerConfig } from '../apiManager';

const CodeServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getCodeList: (includeInactive?: boolean): Promise<CodeListNormalized[]> =>
      HTTPBase.get(`farm/${config.farmId}/codes`, {
        params: {
          includeinactive: includeInactive,
        },
      }).then((res) => res.data),
  };
};

export default CodeServiceFactory;
